import cx from 'classnames'
import { useContext, useMemo } from 'react'

import { formatPrice } from '../../lib/price'
import { FrameBuilderShopContext } from '../../contexts/shop-context'

interface PriceBadgeProps {
  price: number
  disabled?: boolean
  showPlusSign?: boolean
  className?: string
}

const PriceBadge = ({
  price,
  disabled = false,
  showPlusSign = false,
  className,
}: PriceBadgeProps) => {
  const { currency, taxRate } = useContext(FrameBuilderShopContext)

  const priceString = useMemo(() => {
    const priceWithTax = price * (1 + taxRate)
    const formattedPrice = formatPrice(priceWithTax)
    const currencyValue = [formattedPrice, currency].filter(Boolean).join(' ')

    return `${showPlusSign && price > 0 ? '+' : ''}${currencyValue}`
  }, [currency, taxRate, showPlusSign, price])

  return (
    <div
      className={cx(
        'inline-block py-1 px-2 rounded text-xs text-white leading-4',
        {
          'line-through bg-gray-500': disabled,
          'bg-black': !disabled,
        },
        className,
      )}
    >
      {priceString}
    </div>
  )
}

export default PriceBadge
